export default __webpack_public_path__ + "static/media/1.ec6365c1.jpeg";